/**
 * 未来平台埋点
 * 平台：https://tlog.talbrain.com/
 * API 文档：https://npm.100tal.com/#/detial?name=%40peiyou%2Fxesanalytics
 * 产品文档：https://wiki.zhiyinlou.com/pages/viewpage.action?pageId=170956725
 * 获取项目公参接口：https://wiki.zhiyinlou.com/pages/viewpage.action?pageId=174666712
 */
/* eslint func-style: "off" */
/* eslint no-undefined: "off" */
/* eslint arrow-parens: "off" */

import XesAnalytics from '@peiyou/xesanalytics/dist';
import UAParser from 'ua-parser-js';
// import store from '@/store'
import {isInPc, isInXES, isInXESPad, fr} from './checkUa';
// import { getBusProps } from '@/interaction/api/track'
const xesAnalytics = new XesAnalytics({
    event_env: process.env.NODE_ENV === 'production' ? 'prod' : 'test', // 数据上报环境，prod=生产环境，test=测试环境
    proj_id: '013_00203', // 项目id，必传，集团未来埋点平台申请 [小猴编程: 013_00203]
    show_log: ['development', 'test'].includes(process.env.NODE_ENV), // 是否开启日志打印，默认关闭
    auto_track: false, // 是否开启全埋点，默认关闭
    collect_tags: {}, // 是否开启其他任意元素的全埋点采集（默认不采集），详见全埋点说明模块
    // eslint-disable-next-line max-len
    source: '8', // 来源，必传，取值逻辑参考(1=android手机端/2=ios手机端/3=app内嵌h5/4=小程序内嵌h5/5=微信app内游离h5(非小程序)/6=服务器后端/7=QQapp内游离h5/8=Web端/9=ipad端/10=安卓pad/11=小程序原生/12=授课端/13=新辅导端/14=老辅导端/100=其它)
    saas: false // 是否埋点上传地址是saas部署的域名，传true为saas上传的域名地址，不传或者传false为培优埋点地址,默认值为false
});

// eslint-disable-next-line valid-jsdoc
/**
 * 去除对象中，值为 undefined、null、空字符串 的 key
 * @param {*} obj 要检查的对象
 * @returns 去除值为 undefined、null 的 key 后的对象
 */
const removeNull = (obj = {}) => Object.entries(obj).reduce((total, [key, value]) => {
    if (![undefined, null, ''].includes(value)) {
        // eslint-disable-next-line no-param-reassign
        total[key] = value;
    }
    return total;
}, {});

/** 设置用户信息相关的用户参数和公共业务参数 */
export function xesInitUser () {
    const profile = {
        user_id: '', // 用户ID, 请求登录接口返回的 id || 如果学生登录返回的是：stu_id || 如果是教师登录返回的是empNo
        user_name: '', // 用户名称
        user_role: '', // 角色 '0'老师 ‘1’ 学生
        city_code: '', // 分校编码 "city_code": "028",
        teacher_type: '', // 教师类型
        user_state: '', // '0' 未登录，'1' 已登陆
        grade: '', // 年级 "grade": "三年级", 只有学生返回
        grade_id: '', // 年级ID 只有学生返回
        city: '' // 分校 "city_name": "成都", 学生端接口返回，教师端前端自己获取
    };
    xesAnalytics.setProfile(profile); // 重置用户信息
    const pub = {
        school_level: '', // 分校
        user_state: '0' // '0' 未登录，'1' 已登陆
    };

    // 标注来源
    let terminal = isInPc ? 'XiaohouPC' : new UAParser().getBrowser().name;
    if (isInXES) terminal = isInXESPad ? 'XesPad' : 'XesPC';
    if (fr === 'ccroom') terminal = 'XianxiaPC';
    if (['xesappteacode', 'xesapptearesult'].includes(fr)) terminal = 'TeacherPC';
    pub.terminal = terminal;

    const userInfo = JSON.parse(localStorage.getItem('XIAOHOUCODE_USERINFO') || '{}');
    const {
        // eslint-disable-next-line camelcase
        id, stu_id, empNo, realName, cityCode, city, grdName, grdId, schoolLevel = ''
    } = userInfo;

    // 分校
    pub.school_level = schoolLevel;

    if (!id && !stu_id && !empNo) {
        // 未登录
        profile.user_state = '0';
        pub.user_state = '0';
    } else {
        const role = localStorage.getItem('XIAOHOUCODE_USER') || '';
        const teacherCity = localStorage.getItem('CITY');
        profile.user_state = '1';
        profile.user_id = id || stu_id || empNo;
        profile.user_name = realName;
        profile.user_role = role;
        profile.city_code = cityCode;
        profile.city = city || teacherCity;

        if (role === '0') {
            // 教师
            profile.teacher_type = localStorage.getItem('XIAOHOUCODE_TEACHERTYPE') || ''; // 0主讲老师 1辅导老师
        } else {
        // 学生
            profile.grade = grdName;
            profile.grade_id = grdId;
        }
    }

    xesAnalytics.setProfile(removeNull(profile));
    xesAnalytics.registerPage(pub);
}

// eslint-disable-next-line valid-jsdoc
/**
 * 新增或改变业务公共参数
 * @param {{[key: string]: any}} publicData 新增或改变的项目公参
 */
export function setXESPublic (publicData = {}) {
    xesAnalytics.registerPage(removeNull(publicData));
}

/**
 * 清除业务公共参数
 * @param {string[]} extra 除了文档里基本的业务公共参数（不包括school_level），还需要清除的 key
 */
export function clearXESPublic (extra = []) {
    // eslint-disable-next-line no-underscore-dangle
    const busProps = xesAnalytics._state.commonBusProps;
    const keys = new Set([
        'level_name',
        'language',
        'year',
        'lesson_id',
        'term_name',
        'class_type',
        'level_id',
        'course_id',
        'term_id',
        'cla_id',
        ...extra
    ]);
    Object.keys(busProps).forEach(key => keys.has(key) && delete busProps[key]);
}

/**
 * 把键名中的 大写字母 替换为 _小写字母，如 classLevelName => class_level_name
 * 并强对应文档中的项目公参，不然校验有错误
 * @param {*} obj 需要转换的对象
 * @returns 转换后的对象
 */
// const upToUnderscore = (obj = {}) =>
//   Object.entries(obj).reduce((total, [key, value]) => {
//     if (['courseName', 'classType'].includes(key)) {
//       return total
//     }

//     let nKey = key.replace(/([A-Z])/g, (c) => `_${c.toLowerCase()}`)
//     switch (nKey) {
//       case 'class_id':
//         nKey = 'cla_id'
//         break
//       case 'class_type_name':
//         nKey = 'class_type'
//         break
//       case 'class_level_id':
//         nKey = 'level_id'
//         break
//       case 'class_level_name':
//         nKey = 'level_name'
//         break
//     }
//     total[nKey] = value
//     return total
//   }, {})

/**
 * 初始化埋点的项目公参
 * @param {courseId | lessonId | classId} key 字段名
 * @param {string} value 字段值（courseId需要以 '010-' 开头）
 */
// export async function xesInitBus(key, value) {
//   const {
//     data: { data }
//   } = await getBusProps({ key, value })
//   setXESPublic(removeNull(upToUnderscore(data)))
// }

/**
 * 上报点击类型的埋点，适用于 script 中使用
 * @param {string} id 事件ID, 必填
 * @param {object} obj 自定义业务属性，非必填，仅支持一层json结构，不支持多层嵌套
 * @param {function} cb 回调方法，非必填，埋点数据存入队列后执行
 */
export function xesClick (id, obj, cb) {
    xesAnalytics.track(id, obj, cb);
}
// eslint-disable-next-line require-jsdoc
export function scratchClick (id = '', obj = {}, cb) {
    obj.page_name = 'Scratch编辑器';
    xesAnalytics.track(id, obj, cb);
}


/**
 * 上报浏览类型的埋点， 适用于 script 中使用
 * @param {string} id 事件ID, 必填
 * @param {object} obj 自定义业务属性，非必填，仅支持一层json结构，不支持多层嵌套
 * @param {function} cb 回调方法，非必填，埋点数据存入队列后执行
 */
export function xesView (id, obj, cb) {
    xesAnalytics.view(id, obj, cb);
}
// eslint-disable-next-line require-jsdoc
export function scratchView (id = '', obj = {}, cb) {
    obj.page_name = 'Scratch编辑器';
    xesAnalytics.view(id, obj, cb);
}

// 手动登录
xesInitUser();
// 登录，需要重新设置用户信息和公共参数
window.addEventListener('storage', (e) => {
    if (e.key === 'XIAOHOUCODE_USERINFO' && e.newValue) {
        xesInitUser();
    }
});
// 从其他应用回退，可能被缓存，不再重新重新加载整个应用，则用户信息可能不会被设置上
window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
        xesInitUser();
    }
});
